// Casilla de consentimiento: checkbox, título y descripción con «Leer documento». La usan el paso 01
// del wizard y el panel Cliente del carrito de accesorios.
import { toast } from 'sonner';
import { cn } from '@/lib/cn';

// Interino: los PDF se sirven de `public/legal/` hasta que `GET /wizard/legal-documents/{type}`
// entregue la URL firmada del bucket (TD-005 del silo).
const LEGAL_DOC_URL: Record<string, string> = {
    PRIVACY: '/legal/aviso-privacidad.pdf',
    PCF_CONTRACT: '/legal/contrato-pago-confiado.pdf',
};

/** `locked` = el cliente ya aceptó y está guardado: se muestra marcada y no se puede tocar. */
export function ConsentCheck({
    checked,
    onChange,
    locked = false,
    title,
    description,
    docType,
    idPrefix = 'consent',
}: {
    checked: boolean;
    onChange: (v: boolean) => void;
    locked?: boolean;
    title: string;
    description: string;
    docType: string;
    idPrefix?: string;
}) {
    const id = `${idPrefix}-${docType}`;
    return (
        <label
            htmlFor={id}
            className={cn(
                'flex flex-wrap items-start gap-x-3 gap-y-1 rounded-md border border-border p-3 transition-colors',
                locked ? 'cursor-default' : 'cursor-pointer hover:bg-accent/40',
                checked && 'border-success-soft-border bg-success-soft/50',
            )}
        >
            <input
                id={id}
                type="checkbox"
                checked={checked}
                disabled={locked}
                onChange={(e) => {
                    onChange(e.target.checked);
                }}
                className="mt-0.5 size-4 accent-primary"
            />
            <span className="text-[13px] font-medium">{title}</span>
            <span className="w-full pl-7 text-[11.5px] leading-relaxed text-muted-foreground">
                {description}{' '}
                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        const url = LEGAL_DOC_URL[docType];
                        if (!url) {
                            toast.error('Documento no disponible.');
                            return;
                        }
                        window.open(url, '_blank', 'noopener,noreferrer');
                    }}
                    className="underline decoration-dotted transition-colors hover:text-foreground"
                >
                    Leer documento
                </button>
            </span>
        </label>
    );
}
